import { Button } from "antd";
import { useState } from "react";
import styled from "styled-components";

const StyledSeeMore = styled(Button)`
  padding: 0;
  margin-left: 8px;
  font-size: 12px;
  height: auto;
  line-height: inherit;
`;

const StyledFooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

const StyledAddRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`;

function CompactSectionWrapper({ items = [], renderItem, entityName = "item", addButton = null }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!items || items.length === 0) {
    return (
      <>
        {items?.map((item, index) => renderItem(item, index))}
        {addButton && items?.length > 0 && <StyledAddRow>{addButton}</StyledAddRow>}
      </>
    );
  }

  // In compact mode, show only the primary (first) entry
  const primaryItem = items[0];
  const remainingCount = items.length - 1;

  if (isExpanded) {
    return (
      <>
        {items.map((item, index) => renderItem(item, index))}
        <StyledFooterRow>
          {remainingCount > 0 ? (
            <StyledSeeMore type="link" onClick={() => setIsExpanded(false)}>
              Show less
            </StyledSeeMore>
          ) : (
            <span />
          )}
          {addButton}
        </StyledFooterRow>
      </>
    );
  }

  return (
    <>
      {renderItem(primaryItem, 0)}
      <StyledFooterRow>
        {remainingCount > 0 ? (
          <StyledSeeMore type="link" onClick={() => setIsExpanded(true)}>
            See more ({remainingCount} more {remainingCount === 1 ? entityName : `${entityName}s`})
          </StyledSeeMore>
        ) : (
          <span />
        )}
        {addButton}
      </StyledFooterRow>
    </>
  );
}

export default CompactSectionWrapper;
